module.exports = __webpack_public_path__ + "img/Group 28038@2x.4c43a13c.png";